export enum CalendarEndpointType {
    Outlook,
    OutlookGroup,
    TeamsCalendars,
}
